/** @graphql cc **/

import gql from 'graphql-tag';

export const AdfDocQuery = gql`
	query AdfDocQuery($contentId: ID, $status: [String]) {
		singleContent(id: $contentId, status: $status) {
			id
			body {
				atlas_doc_format {
					value
				}
			}
		}
	}
`;
